import axios from "axios";
import { ErroMsg, SucessoMsg } from "../../frontend/contents/VariaveisGlobais";

async function DisparaEmail({ destinatario, assunto, corpo, cc, anexos, showMsg = false, sender }) {
    const formData = new FormData();

    formData.append("destinatario", destinatario);
    formData.append("assunto", assunto);
    formData.append("corpo", corpo);
    if (cc) formData.append("cc", cc);
    if (sender) formData.append("sender", sender);

    if (anexos) {
        anexos.forEach((anexo) => {
            formData.append("anexos", anexo.anexo, anexo.nome);
        });
    }

    const URLMethod = `${window._env_?.REACT_APP_URL}:${window._env_?.REACT_APP_PORT}/api/enviarEmail`;

    try {
        await axios.post(URLMethod, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                // Removido o Authorization, token agora vem via cookie HttpOnly
            },
            withCredentials: true,  // MUITO IMPORTANTE para enviar cookies junto na requisição
        });

        if (showMsg)
            SucessoMsg("E-mail enviado com sucesso!");

    } catch (err) {
        if (err.response) {
            if (showMsg)
                ErroMsg(`Erro ao enviar e-mail! Código: ${err.response.status} - ${err.response.statusText}`);
        } else {
            if (showMsg)
                ErroMsg(`Erro ao enviar e-mail! ${err.message}`);
        }
    }
}

export default DisparaEmail;
